"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _brand = _interopRequireDefault(require("./brand.svg"));
const _excluded = ["inverse"]; // Display the logo and word mark
const logoHeight = 14;
const Container = _styledComponents.default.div`
  display: flex;
  flex-direction: row;
  padding: 0;
  align-items: center;

  img {
    display: block;
    width: 76.4px;
    height: 16px;
  }
`;
const Logo = _styledComponents.default.img`
  height: ${logoHeight}px;
`;
const Brand = _ref => {
  let others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container, others, /*#__PURE__*/_react.default.createElement(Logo, {
    src: _brand.default,
    alt: "Anvil Logo"
  }));
};
Brand.defaultProps = {
  inverse: false
};
Brand.propTypes = {
  inverse: _propTypes.default.bool
};
var _default = exports.default = Brand;